import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_LINK_DATA_PERMISSIONS,
} from '../../../actions/actionTypes';

const linkDataPermissions = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_LINK_DATA_PERMISSIONS
);

export default linkDataPermissions;
